import { ActionIcon, Flex, Title, Tooltip } from '@mantine/core';
import { IconBuildings, IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import BaseClickable from '@/components/ui/BaseClickable';
import { ROUTES } from '@/configs/routes';
import useHistoryNavigationState from '@/hooks/useHistoryNavigationState';
import { useNavigateToOrganizationHome } from '@/hooks/useNavigateToOrganizationHome';
import { organizationsStore } from '@/stores/global/RootStore';

import s from './Back.module.scss';

const Back: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const navigateToOrganizationHome = useNavigateToOrganizationHome();
  const organization = organizationsStore.getOrganizationById(id as string);

  const historyState = useHistoryNavigationState();

  const canGoBack = historyState.index > 0;
  const canGoForward = historyState.index < historyState.stack.length - 1;

  const handleHistoryBack = React.useCallback(() => navigate(-1), [navigate]);
  const handleHistoryForward = React.useCallback(() => navigate(1), [navigate]);
  const handleHome = React.useCallback(() => {
    navigateToOrganizationHome({ organizationId: id ?? '', isPhone: false, withResetChatState: true });
  }, [id, navigateToOrganizationHome]);

  return (
    <Flex className={s.root} gap="xs" align="center" justify="space-between">
      <Flex gap="md" align="center">
        <Tooltip label="К списку организаций" withArrow position="bottom">
          <ActionIcon
            component={Link}
            to={ROUTES.root.path}
            variant="transparent"
            size="lg"
            c="dark"
            aria-label="К списку организаций"
            className={s.root__organizations}
          >
            <IconBuildings size={24} />
          </ActionIcon>
        </Tooltip>
        <BaseClickable onClick={handleHome} className={s.root__home}>
          <Title size="h4" fw={700}>
            {organization?.name}
          </Title>
        </BaseClickable>
      </Flex>
      <Flex gap="xs" align="center">
        <Tooltip label="Назад по истории" withArrow position="bottom">
          <ActionIcon
            variant="transparent"
            size="lg"
            c="dark"
            onClick={handleHistoryBack}
            className={cn(!canGoBack && s.root__button_disabled)}
          >
            <IconChevronLeft size={24} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Вперед по истории" withArrow position="bottom">
          <ActionIcon
            variant="transparent"
            size="lg"
            c="dark"
            onClick={handleHistoryForward}
            className={cn(!canGoForward && s.root__button_disabled)}
          >
            <IconChevronRight size={24} />
          </ActionIcon>
        </Tooltip>
      </Flex>
    </Flex>
  );
};

export default observer(Back);
